export default Object.freeze([
    { value: "InOffice", label: "In-Office or On-Site", description: "Full Time at an Office Workspace" },
    { value: "Hybrid", label: "Hybrid", description: "A Mix of In-Office and Remote" },
    { value: "Remote", label: "Remote", description: "Full time at a Remote Workspace" }
]);